"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shake = exports.update = exports.get = void 0;
var rando_sidecar_1 = require("@lib/rando-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var tumult = require('tumult');
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
    }
    return _obj;
}
exports.get = get;
function create() {
    var obj = {
        shakeX: 0,
        shakeY: 0,
        secondsLeft: 0,
        maxSeconds: 0,
        simplex2a: new tumult.Simplex2(rando_sidecar_1.rando.f(0, 1)),
        simplex2b: new tumult.Simplex2(rando_sidecar_1.rando.f(0, 1)),
    };
    return obj;
}
var _shakeElapsedTime = 0;
function update() {
    // let es = common.getElapsedTime()
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    _shakeElapsedTime += ds; // Don't keep shaking while paused
    var et = _shakeElapsedTime;
    var obj = get();
    if (obj.secondsLeft > 0) {
        var fadeOut = obj.secondsLeft / obj.maxSeconds;
        var fade = fadeOut;
        obj.secondsLeft -= ds;
        var elapsed = obj.maxSeconds - obj.secondsLeft;
        var fadeInSeconds = 0.1;
        if (elapsed < fadeInSeconds) {
            var fadeIn = elapsed / fadeInSeconds;
            // console.log('fade in', fadeIn, elapsed, fade)
            if (fadeIn < fade) {
                fade = fadeIn;
            }
        }
        // See: http://www.briscoe.ca/notes/camera-shake/
        var seed = 0;
        var speed = 0.25;
        var maxMagnitude = 50;
        var noiseMagnitude = 25;
        var dirX = 1;
        var dirY = 0;
        // Use sine to get a value that oscillates with time. This makes our camera
        // move back and forth. Scale time with _Speed to shrink or grow the period of
        // the oscillation which makes the shake faster or slower.
        // Since shakes are tied to time, you may see multiple objects shaking in sync.
        // The _Seed value allows you to offset shakes. You could set it to a random
        // value in Start.
        var sin = (Math.sin(speed * (seed + et)) + 1) / 2;
        var cos = (Math.cos(speed * (seed + et)) + 1) / 2;
        // Shake along a direction, but use Perlin noise to get an offset. Scale
        // the noise (which is in [-0.5,0.5]) to adjust the amount of deviation
        // from our direction.
        var simX = obj.simplex2a.gen(sin * noiseMagnitude, cos * noiseMagnitude);
        var simY = obj.simplex2b.gen(sin * noiseMagnitude, cos * noiseMagnitude);
        // console.log(sin, cos, simX, simY)
        // var direction = _Direction + Get2DNoise(_Seed) * _NoiseMagnitude
        // Normalize the result (limit vector length to 1) to ensure we're never
        // more than _MaxMagnitude away from neutral.
        // direction.Normalize()
        // Multiply our bits together to find our position this frame. Since we're
        // using two continuous functions (sine and perlin), we won't be far off
        // from where we were last frame.
        // Additionally, we have a fade value so we can reduce the shake strength
        // over time.
        // _Target.localPosition = direction * sin * _MaxMagnitude * _FadeOut
        obj.shakeX = simX * maxMagnitude * fade;
        obj.shakeY = simY * maxMagnitude * fade;
    }
    else {
        obj.shakeX = 0;
        obj.shakeY = 0;
    }
}
exports.update = update;
function shake() {
    // console.log('camera shake!')
    var obj = get();
    obj.maxSeconds = 1.5;
    obj.secondsLeft = obj.maxSeconds;
}
exports.shake = shake;
